if (!customElements.get('product-accessories')) {
  customElements.define(
    'product-accessories',
    class ProductAccessories extends HTMLElement {
      constructor() {
        super();
        this.selectedAccessories = [];
        this.init();
      }

      connectedCallback() {
        if (this._pendingStarted) return;
        this._pendingStarted = true;
        this.loadPendingAccessories();
      }

      init() {
        this.checkboxes = this.querySelectorAll('.product-accessories__checkbox');
        this.quantityInputs = this.querySelectorAll('.product-accessories__quantity-input');
        this.totalElement = this.querySelector('[data-accessories-total]');
        this.productForm = document.getElementById(`product-form-${this.dataset.section}`);
        
        // 绑定复选框事件
        this.checkboxes.forEach(checkbox => {
          checkbox.addEventListener('change', this.handleAccessoryChange.bind(this));
          this.setItemSelectionState(this.getItem(checkbox), checkbox.checked);
        });

        // 绑定数量选择器事件
        this.quantityInputs.forEach(input => {
          input.addEventListener('change', this.handleQuantityChange.bind(this));
          input.addEventListener('input', this.handleQuantityInput.bind(this));
        });

        // 绑定数量按钮事件
        this.querySelectorAll('.product-accessories__quantity-btn--minus').forEach(btn => {
          btn.addEventListener('click', this.handleQuantityButtonClick.bind(this));
        });
        this.querySelectorAll('.product-accessories__quantity-btn--plus').forEach(btn => {
          btn.addEventListener('click', this.handleQuantityButtonClick.bind(this));
        });

        this.toggleButton = this.querySelector('.product-accessories__toggle');
        if (this.toggleButton) {
          this.toggleButton.addEventListener('click', this.handleSoldOutToggle.bind(this));
        }

        // 监听变体变化（如果变体切换需要更新配件）
        if (window.subscribe && window.PUB_SUB_EVENTS) {
          this.variantChangeUnsubscriber = window.subscribe(
            window.PUB_SUB_EVENTS.variantChange,
            this.onVariantChange.bind(this)
          );
        }

        // 恢复浏览器缓存中的配件选择状态（方案1）
        this.restoreStateFromDOM();
      }

      restoreStateFromDOM() {
        // 遍历所有复选框，恢复已勾选的配件状态
        this.checkboxes.forEach(checkbox => {
          if (checkbox.checked) {
            const variantId = parseInt(checkbox.value);
            const price = parseInt(checkbox.dataset.accessoryPrice || 0);
            const item = this.getItem(checkbox);
            
            // 获取数量
            const quantityInput = item.querySelector('.product-accessories__quantity-input');
            const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
            
            // 检查是否已存在
            const existingIndex = this.selectedAccessories.findIndex(item => item.variantId === variantId);
            if (existingIndex >= 0) {
              this.selectedAccessories[existingIndex].quantity = quantity;
            } else {
              this.selectedAccessories.push({
                variantId: variantId,
                price: price,
                quantity: quantity
              });
            }
          }
        });
        
        // 更新总价和表单数据
        if (this.selectedAccessories.length > 0) {
          this.updateTotal();
          this.updateProductForm();
        }
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      onVariantChange(event) {
        // 如果变体切换，可以在这里更新配件显示
        // 当前实现：配件是基于产品级别的，所以不需要更新
        // 如果需要基于变体显示不同配件，可以在这里实现
      }

      handleSoldOutToggle() {
        const expanded = this.classList.toggle('is-expanded');
        if (this.toggleButton) {
          this.toggleButton.setAttribute('aria-expanded', String(expanded));
        }
        const showLabel = this.querySelector('.product-accessories__toggle-show');
        const hideLabel = this.querySelector('.product-accessories__toggle-hide');
        if (showLabel) showLabel.classList.toggle('hidden', expanded);
        if (hideLabel) hideLabel.classList.toggle('hidden', !expanded);
      }

      handleAccessoryChange(event) {
        const checkbox = event.target;
        const variantId = parseInt(checkbox.value);
        const price = parseInt(checkbox.dataset.accessoryPrice || 0);
        const isChecked = checkbox.checked;
        const item = this.getItem(checkbox);

        // 获取数量
        const quantityInput = item.querySelector('.product-accessories__quantity-input');
        const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

        if (isChecked) {
          // 检查是否已存在
          const existingIndex = this.selectedAccessories.findIndex(item => item.variantId === variantId);
          if (existingIndex >= 0) {
            this.selectedAccessories[existingIndex].quantity = quantity;
          } else {
            this.selectedAccessories.push({
              variantId: variantId,
              price: price,
              quantity: quantity
            });
          }
        } else {
          this.selectedAccessories = this.selectedAccessories.filter(
            item => item.variantId !== variantId
          );
        }

        this.setItemSelectionState(item, isChecked);
        this.updateTotal();
        this.updateProductForm();
      }

      handleQuantityChange(event) {
        const input = event.target;
        const variantId = parseInt(input.dataset.accessoryVariantId);
        const quantity = parseInt(input.value) || 1;
        const item = this.getItem(input);
        const checkbox = item.querySelector('.product-accessories__checkbox');
        
        // 确保数量在有效范围内
        const min = parseInt(input.min) || 1;
        const max = parseInt(input.max) || 99;
        const validQuantity = Math.max(min, Math.min(max, quantity));
        input.value = validQuantity;

        // 如果已选中，更新数量
        if (checkbox && checkbox.checked) {
          const existingIndex = this.selectedAccessories.findIndex(item => item.variantId === variantId);
          if (existingIndex >= 0) {
            this.selectedAccessories[existingIndex].quantity = validQuantity;
            this.updateTotal();
            this.updateProductForm();
          }
        } else if (checkbox && !checkbox.disabled && validQuantity > 0) {
          checkbox.checked = true;
          this.handleAccessoryChange({ target: checkbox });
        }
      }

      handleQuantityInput(event) {
        // 实时验证输入
        const input = event.target;
        const value = parseInt(input.value);
        const min = parseInt(input.min) || 1;
        const max = parseInt(input.max) || 99;
        
        if (isNaN(value) || value < min) {
          input.value = min;
        } else if (value > max) {
          input.value = max;
        }
      }

      handleQuantityButtonClick(event) {
        event.preventDefault();
        const button = event.target.closest('button');
        const item = this.getItem(button);
        const input = item.querySelector('.product-accessories__quantity-input');
        const checkbox = item.querySelector('.product-accessories__checkbox');
        
        if (!input) return;

        const currentValue = parseInt(input.value) || 1;
        const min = parseInt(input.min) || 1;
        const max = parseInt(input.max) || 99;
        let newValue = currentValue;

        if (button.classList.contains('product-accessories__quantity-btn--plus')) {
          newValue = Math.min(max, currentValue + 1);
        } else if (button.classList.contains('product-accessories__quantity-btn--minus')) {
          newValue = Math.max(min, currentValue - 1);
        }

        input.value = newValue;
        input.dispatchEvent(new Event('change', { bubbles: true }));

        // 如果已选中，自动更新
        if (checkbox && checkbox.checked) {
          this.handleQuantityChange({ target: input });
        } else if (checkbox && !checkbox.disabled && newValue > 0) {
          checkbox.checked = true;
          this.handleAccessoryChange({ target: checkbox });
        }
      }

      getItem(element) {
        return element.closest('.product-accessories__item');
      }

      setItemSelectionState(item, isSelected) {
        if (!item) return;
        const card = item.querySelector('.product-accessories__card');
        if (!card) return;
        card.classList.toggle('is-selected', Boolean(isSelected));
      }

      updateTotal() {
        const total = this.selectedAccessories.reduce((sum, item) => {
          return sum + (item.price * (item.quantity || 1));
        }, 0);
        
        if (this.totalElement) {
          // 格式化价格
          const formattedPrice = this.formatMoney(total);
          this.totalElement.textContent = formattedPrice;
          this.totalElement.dataset.accessoriesTotal = total;
        }
      }

      updateProductForm() {
        // 将选中的配件数据存储到表单的 data 属性中（包含数量）
        if (this.productForm) {
          this.productForm.dataset.selectedAccessories = JSON.stringify(
            this.selectedAccessories.map(item => ({
              variantId: item.variantId,
              quantity: item.quantity || 1
            }))
          );
        }
      }

      getSelectedAccessories() {
        return this.selectedAccessories.map(item => ({
          variantId: item.variantId,
          quantity: item.quantity || 1
        }));
      }

      formatMoney(cents, format) {
        // 使用 Shopify 的货币格式化
        if (window.Shopify && window.Shopify.formatMoney) {
          if (format) return window.Shopify.formatMoney(cents, format);
          return window.Shopify.formatMoney(cents);
        }
        // 备用方案：简单格式化
        const amount = (cents / 100).toFixed(2);
        const currencySymbol = window.Shopify?.currency?.active || '$';
        return `${currencySymbol}${amount}`;
      }

      async loadPendingAccessories() {
        const node = this.querySelector('[data-accessory-pending]');
        if (!node || !node.textContent.trim()) return;

        let pending = [];
        try {
          pending = JSON.parse(node.textContent);
        } catch (error) {
          return;
        }
        if (!Array.isArray(pending) || !pending.length) return;

        const list = this.querySelector('.product-accessories__list');
        if (!list) return;

        const loaded = await Promise.all(pending.map(async (entry) => {
          const handle = entry && entry.handle;
          if (!handle) return null;
          try {
            const response = await fetch(`/products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin' });
            if (!response.ok) return null;
            const product = await response.json();
            if (!product || product.handle !== handle) return null;
            const variant = this.pickAccessoryVariant(product);
            if (!variant) return null;
            return {
              index: Number(entry.index),
              product,
              variant,
              available: Boolean(variant.available)
            };
          } catch (error) {
            return null;
          }
        }));

        loaded
          .filter(Boolean)
          .sort((a, b) => a.index - b.index)
          .forEach((entry) => {
            const card = this.buildAccessoryCard(entry);
            this.insertAccessoryCard(list, card, entry.index, entry.available);
            this.bindAccessoryItem(card);
          });

        this.applyPreviewLimit();

        if (!list.querySelector('[data-accessory-available="true"]')) {
          this.hidden = true;
        }
      }

      pickAccessoryVariant(product) {
        const variants = Array.isArray(product.variants) ? product.variants : [];
        return variants.find((variant) => variant && variant.available) || variants[0] || null;
      }

      accessoryMaxQuantity(variant) {
        if (
          variant.inventory_management &&
          variant.inventory_policy !== 'continue' &&
          typeof variant.inventory_quantity === 'number'
        ) {
          return Math.max(1, variant.inventory_quantity);
        }
        return 99;
      }

      accessoryImageUrl(product) {
        let src = product.featured_image || '';
        if (!src && Array.isArray(product.images) && product.images.length) src = product.images[0];
        if (src && typeof src !== 'string') src = src.src || src.url || '';
        if (!src) return '';
        if (src.indexOf('//') === 0) src = `https:${src}`;
        return `${src}${src.indexOf('?') === -1 ? '?' : '&'}width=128`;
      }

      fillTemplate(template, token, value) {
        return String(template || '').split(token).join(value);
      }

      buildAccessoryCard(entry) {
        const { product, variant, index, available } = entry;
        const price = Number(variant.price) || 0;
        const compare = variant.compare_at_price == null ? 0 : Number(variant.compare_at_price);
        const onSale = compare > price;
        const title = product.title || '';
        const maxQuantity = this.accessoryMaxQuantity(variant);
        const moneyFormat = this.dataset.moneyFormat || '';

        const item = document.createElement('div');
        item.className = 'product-accessories__item';
        if (!available) item.classList.add('product-accessories__item--sold-out');
        item.dataset.accessoryHandle = product.handle;
        item.dataset.accessoryIndex = String(index);
        item.dataset.accessoryProductId = String(product.id);
        item.dataset.accessoryVariantId = String(variant.id);
        item.dataset.accessoryAvailable = available ? 'true' : 'false';

        const label = document.createElement('label');
        label.className = 'product-accessories__card';

        const checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.className = 'product-accessories__checkbox';
        checkbox.name = 'accessories[]';
        checkbox.value = String(variant.id);
        checkbox.dataset.accessoryPrice = String(price);
        if (!available) checkbox.disabled = true;

        const media = document.createElement('div');
        media.className = 'product-accessories__media';
        const imageUrl = this.accessoryImageUrl(product);
        if (imageUrl) {
          const image = document.createElement('img');
          image.src = imageUrl;
          image.alt = title;
          image.loading = 'lazy';
          image.width = 64;
          image.height = 64;
          media.appendChild(image);
        }

        const info = document.createElement('div');
        info.className = 'product-accessories__info';

        const name = document.createElement('h4');
        name.className = 'product-accessories__name';
        name.textContent = title;

        const priceRow = document.createElement('div');
        priceRow.className = 'product-accessories__price-row';
        const current = document.createElement('span');
        current.className = 'product-accessories__price-current';
        current.textContent = this.formatMoney(price, moneyFormat);
        priceRow.appendChild(current);
        if (onSale) {
          const compareEl = document.createElement('span');
          compareEl.className = 'product-accessories__price-compare';
          compareEl.textContent = this.formatMoney(compare, moneyFormat);
          priceRow.appendChild(compareEl);
        }

        info.append(name, priceRow);
        if (onSale && this.dataset.labelSale) {
          const badge = document.createElement('span');
          badge.className = 'product-accessories__badge';
          badge.textContent = this.dataset.labelSale;
          info.appendChild(badge);
        }
        if (!available) {
          const stock = document.createElement('span');
          stock.className = 'product-accessories__stock product-accessories__stock--out';
          stock.textContent = this.dataset.labelSoldOut || '';
          info.appendChild(stock);
        }

        const actions = document.createElement('div');
        actions.className = 'product-accessories__actions';
        const details = document.createElement('a');
        details.className = 'product-accessories__details';
        details.href = product.url || `/products/${product.handle}`;
        details.target = '_blank';
        details.rel = 'noopener';
        details.textContent = 'Details';
        actions.appendChild(details);

        if (available) {
          const quantity = document.createElement('div');
          quantity.className = 'product-accessories__quantity';
          const decreaseLabel = this.fillTemplate(this.dataset.qtyDecreaseTemplate, '@@PRODUCT@@', title);
          const increaseLabel = this.fillTemplate(this.dataset.qtyIncreaseTemplate, '@@PRODUCT@@', title);
          const inputLabel = this.fillTemplate(this.dataset.qtyInputTemplate, '@@PRODUCT@@', title);

          const minus = document.createElement('button');
          minus.type = 'button';
          minus.className = 'product-accessories__quantity-btn product-accessories__quantity-btn--minus';
          minus.setAttribute('aria-label', decreaseLabel);
          minus.innerHTML = '<span class="visually-hidden"></span><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 6H10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
          minus.querySelector('.visually-hidden').textContent = decreaseLabel;

          const input = document.createElement('input');
          input.type = 'number';
          input.className = 'product-accessories__quantity-input';
          input.value = '1';
          input.min = '1';
          input.max = String(maxQuantity);
          input.dataset.max = String(maxQuantity);
          input.dataset.accessoryVariantId = String(variant.id);
          input.setAttribute('aria-label', inputLabel);

          const plus = document.createElement('button');
          plus.type = 'button';
          plus.className = 'product-accessories__quantity-btn product-accessories__quantity-btn--plus';
          plus.setAttribute('aria-label', increaseLabel);
          plus.innerHTML = '<span class="visually-hidden"></span><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 2V10M2 6H10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
          plus.querySelector('.visually-hidden').textContent = increaseLabel;

          quantity.append(minus, input, plus);
          actions.appendChild(quantity);
        }

        label.append(checkbox, media, info, actions);
        item.appendChild(label);
        return item;
      }

      insertAccessoryCard(list, card, index, available) {
        const items = Array.from(list.querySelectorAll('.product-accessories__item'));
        const before = items.find((item) => {
          const itemIndex = parseInt(item.dataset.accessoryIndex, 10);
          const itemAvailable = item.dataset.accessoryAvailable === 'true';
          if (available) {
            if (!itemAvailable) return true;
            return itemIndex > index;
          }
          if (itemAvailable) return false;
          return itemIndex > index;
        });
        if (before) list.insertBefore(card, before);
        else list.appendChild(card);
      }

      bindAccessoryItem(item) {
        const checkbox = item.querySelector('.product-accessories__checkbox');
        if (checkbox) {
          checkbox.addEventListener('change', this.handleAccessoryChange.bind(this));
          this.setItemSelectionState(item, checkbox.checked);
        }
        const input = item.querySelector('.product-accessories__quantity-input');
        if (input) {
          input.addEventListener('change', this.handleQuantityChange.bind(this));
          input.addEventListener('input', this.handleQuantityInput.bind(this));
        }
        item.querySelectorAll('.product-accessories__quantity-btn').forEach((button) => {
          button.addEventListener('click', this.handleQuantityButtonClick.bind(this));
        });
      }

      applyPreviewLimit() {
        const list = this.querySelector('.product-accessories__list');
        if (!list) return;
        const items = Array.from(list.querySelectorAll('.product-accessories__item'));
        const limit = parseInt(this.dataset.previewLimit, 10) || 2;
        items.forEach((item, index) => {
          item.classList.toggle('product-accessories__item--collapsed', index >= limit);
        });
        const hiddenCount = Math.max(0, items.length - limit);
        this.classList.toggle('product-accessories--has-collapsed', hiddenCount > 0);
        this.syncPreviewToggle(hiddenCount);
      }

      syncPreviewToggle(hiddenCount) {
        let footer = this.querySelector('.product-accessories__list-footer');
        if (hiddenCount <= 0) {
          if (footer) footer.hidden = true;
          return;
        }

        if (!footer) {
          footer = document.createElement('div');
          footer.className = 'product-accessories__list-footer';
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'product-accessories__toggle link';
          button.setAttribute('aria-expanded', this.classList.contains('is-expanded') ? 'true' : 'false');
          const list = this.querySelector('.product-accessories__list');
          if (list && list.id) button.setAttribute('aria-controls', list.id);
          const show = document.createElement('span');
          show.className = 'product-accessories__toggle-show';
          if (this.classList.contains('is-expanded')) show.classList.add('hidden');
          const hide = document.createElement('span');
          hide.className = 'product-accessories__toggle-hide';
          hide.textContent = this.dataset.showLessLabel || '';
          if (!this.classList.contains('is-expanded')) hide.classList.add('hidden');
          button.append(show, hide);
          button.addEventListener('click', this.handleSoldOutToggle.bind(this));
          footer.appendChild(button);
          const total = this.querySelector('.product-accessories__total');
          if (total) this.insertBefore(footer, total);
          else this.appendChild(footer);
          this.toggleButton = button;
        } else {
          footer.hidden = false;
        }

        const showLabel = footer.querySelector('.product-accessories__toggle-show');
        const template = this.dataset.showMoreTemplate || '';
        if (showLabel && template.indexOf('@@COUNT@@') !== -1) {
          showLabel.textContent = template.replace('@@COUNT@@', String(hiddenCount));
        }
      }
    }
  );
}

